import { apiUrl } from "config/settings";
import moment from "moment";
import http from 'http'
import { useDispatch, useSelector } from "react-redux";
import { setShowLoading, setShowMassage } from "store/sysSlice";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { Stack, Typography, useTheme } from "@mui/material";
import CustomButton from "components/CustomButton";
import { DAYS_OF_WEEK } from "../const";
import NullCheck from "components/NullCheck";
import { AcUnitOutlined, FmdGoodOutlined } from "@mui/icons-material";
import { MC_DEVICE_TYPE } from "config/const";
import { findKeyByValue } from "config/functions";

const Relay = ({ data, onClose, isConnected, checkWeeklyTime }) => {
    const theme = useTheme();
    const { bt } = useBizTypeTranslation();
    const dispatch = useDispatch()
    const bizPath = useSelector((state) => state?.biz?.data?.path);

    const sendCommand = ({ overrideSchedule = false } = {}) => {
        if (!data?.isConnected)
            return dispatch(setShowMassage({ massage: "MC_IS_DISCONNECTED", type: "error" }));

        if (!isConnected)
            return dispatch(setShowMassage({ massage: "WS_IS_NOT_CONNECTED", type: "info" }));

        dispatch(setShowLoading(true));
        let item = {
            overrideSchedule,
            turnOnDate: data?.turnOnDate ? null : moment(),
            turnOffDate: !data?.turnOnDate ? null : moment(),
            boostPower: data?.turnOnDate ? "0" : data?.boostPower,
            command: data?.turnOnDate ? "off" : "on",
        }

        if ("vibrate" in navigator)
            navigator.vibrate(100);

        dispatch(setShowLoading(true));
        http.patch(`${apiUrl}/mc/sendCommand/${bizPath}/${data?.guid}`, item)
            .then((res) => {
                dispatch(setShowLoading(false));
                onClose()
            })
            .catch((error) => {
                dispatch(setShowLoading(false));
                onClose()
            });
    }

    return (
        <Stack alignItems={{ xs: "stretch", md: "center" }} spacing={2} minWidth={{ xs: '100%', md: 400 }}>

            <Stack direction={{ xs: 'column', md: "row" }} spacing={{ xs: 1, md: 2 }}>

                <NullCheck valueForCheck={data?.deviceType !== MC_DEVICE_TYPE.NONE}>
                    <Stack alignItems="center" direction="row" spacing={0.5}>
                        <AcUnitOutlined fontSize="small" sx={{ color: "primary.main" }} />
                        <Typography variant="body2" color="primary.text">
                            {bt(findKeyByValue(MC_DEVICE_TYPE, data?.deviceType))}
                        </Typography>
                    </Stack>
                </NullCheck>

                <NullCheck valueForCheck={data?.area?.name}>
                    <Stack alignItems="center" direction="row" spacing={0.5}>
                        <FmdGoodOutlined fontSize="small" sx={{ color: "primary.main" }} />
                        <Typography variant="body2" color="primary.text">
                            {data?.area?.name}
                        </Typography>
                    </Stack>
                </NullCheck>
            </Stack>

            <Typography textAlign="center" variant="h6" >
                {data?.turnOnDate
                    ? `${bt('TURN_OFF_DEVICE')} ${data.name} ?`
                    : `${bt('TURN_ON_DEVICE')} ${data.name} ?`
                }
            </Typography>

            <Stack width='100%' direction='row' spacing={2}>
                <CustomButton
                    color="error.main"
                    textColor="error.text"
                    height={45}
                    title='CANCEL'
                    fullWidth
                    onClick={onClose}
                />
                <CustomButton
                    title='CONTINUE'
                    fullWidth
                    onClick={() => checkWeeklyTime({ callbackFunc: sendCommand })}
                    color="success.main"
                    textColor="success.text"
                    height={45}
                />
            </Stack>
        </Stack>
    )
}
export default Relay
